import React, { ChangeEvent, useState } from 'react'
import { DropdownMenuItem } from '@/components/ui/dropdown-menu'
import { Input } from '@/components/ui/input'
import { Search } from 'lucide-react'

import styles from './ClientDetailsRequestsSearchMenuItems.module.scss'

export interface ClientDetailsRequestsSearchMenuItemsProps {
  items: ClientDetailsRequestsSearchMenuItemProps[]
}

interface ClientDetailsRequestsSearchMenuItemProps {
  id: string
  name: string
  function(): void
}

export const ClientDetailsRequestsSearchMenuItems: React.FC<
  ClientDetailsRequestsSearchMenuItemsProps
> = (props) => {
  const { items } = props

  const [requestsSearch, setRequestsSearch] = useState('')

  const handleRequestsSearch = (event: ChangeEvent<HTMLInputElement>) => {
    setRequestsSearch(event.target.value)
  }

  return (
    <div>
      <div className='relative mb-1'>
        <Search className='pointer-events-none absolute top-1.5 left-2 size-4 text-muted-foreground' />
        <Input
          placeholder='Search ...'
          value={requestsSearch}
          onChange={handleRequestsSearch}
          onKeyDown={(event) => event.stopPropagation()}
          className='pl-8'
        />
      </div>
      <div className={styles.menu}>
        {items.filter(filterRequestsSearchItem(requestsSearch)).map((x) => (
          <DropdownMenuItem key={x.id} onSelect={x.function}>
            {x.name}
          </DropdownMenuItem>
        ))}
      </div>
    </div>
  )
}

const filterRequestsSearchItem =
  (requestsSearch: string) => (x: ClientDetailsRequestsSearchMenuItemProps) =>
    x.name.toLowerCase().includes(requestsSearch.toLowerCase())
